
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/overview",
      function () {
        return require("private-next-pages/account/overview.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/overview"])
      });
    }
  